import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
// import { sessionStroe } from '../../../../utils/sessionStorage';

class articleVideo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        isPhotoShow: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.ref = React.createRef();
        this.videoRef = React.createRef();
    }

    state = {
        isShowPopup: false,
        videoHeight: '',
        isShowPlayIcon: true,
    };

    playFlag = true;
    pauseFlag = true;
    videoEnd = false;
    videoPlayed = false;
    videoPause = false;
    isWifiFlag = true;
    is4GFlag = true;
    isWifi = false;
    isContinuePlay = false;

    componentDidUpdate(prevProps) {
        const videoDom = this.videoRef.current;

        if (this.props.isPhotoShow !== prevProps.isPhotoShow) {
            if (this.props.isPhotoShow) {
                videoDom.pause();
                this.setState({
                    isShowPopup: false,
                });
            }
        }
    }

    componentDidMount() {
        this.videoBoxStyleHandle();

        window.addEventListener(
            'resize',
            () => {
                this.videoBoxStyleHandle();
            },
            false,
        );

        this.updateConnectionStatus();
        navigator.connection.addEventListener(
            'change',
            () => {
                this.updateConnectionStatus();
            },
            false,
        );
        this.videoEvent();

        this.videoScrollHandle();
    }

    videoScrollHandle = () => {
        const videoDom = this.videoRef.current;
        let flage = true;

        window.addEventListener('scroll', () => {
            const videoBottom = videoDom.getBoundingClientRect().bottom;

            if (videoBottom <= 0 && flage) {
                videoDom.pause();
                this.setState({
                    isShowPopup: false,
                });
                flage = false;
            }

            if (videoBottom > 0) {
                flage = true;
            }
        });
    };

    updateConnectionStatus = () => {
        const { isShowPopup } = this.state;
        const videoDom = this.videoRef.current;
        const netType =
            (navigator.connection && navigator.connection.type && navigator.connection.type.toLocaleLowerCase()) ||
            'wifi';

        // const { content } = this.props;
        // const guid = content.guid || '';
        // const readUrl =
        //     (sessionStroe.getSession('isAlreadyPlay') && sessionStroe.getSession('isAlreadyPlay').toString()) || '';

        // if (readUrl.includes(guid)) {
        //     this.isWifi = true;
        //     this.isContinuePlay = true;

        //     return false;
        // }
        if (this.isContinuePlay || (window.isAllowedOnDataNet && window.isAllowedOnDataNet())) {
            this.isWifi = true;

            return false;
        }

        if (netType === 'wifi' && this.isWifiFlag) {
            this.isWifiFlag = false;
            this.is4GFlag = true;
            this.isWifi = true;
            if (isShowPopup) {
                videoDom.play();
                this.setState({
                    isShowPopup: false,
                });
            }
        } else if (netType !== 'wifi' && this.is4GFlag) {
            this.isWifiFlag = true;
            this.is4GFlag = false;
            this.isWifi = false;
        }
    };

    videoEvent = () => {
        const videoDom = this.videoRef.current;
        const windowWidth = document.documentElement.clientWidth || document.body.clientWidth;
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;

        videoDom.addEventListener('end', () => {
            this.videoPlayed = false;
            this.videoPause = false;
            this.videoEnd = true;
        });

        videoDom.addEventListener('pause', () => {
            this.videoPlayed = false;
            this.videoPause = true;
            this.videoEnd = false;
        });

        videoDom.addEventListener('play', () => {
            this.videoPlayed = true;
            this.videoPause = false;
            this.videoEnd = false;
            this.setState({
                isShowPlayIcon: false,
            });
        });

        window.setInterval(() => {
            if (this.videoPlayed) {
                if (this.isWifi && this.state.isShowPopup) {
                    this.setState({
                        isShowPopup: false,
                    });
                }

                if (!this.isWifi) {
                    videoDom.pause();
                    this.setState({
                        isShowPopup: true,
                    });
                }
            }
        }, 500);

        window.addEventListener(
            'orientationchange',
            event => {
                if (event.currentTarget.orientation !== 0) {
                    this.isHorizontalScreen = true;
                } else {
                    this.isHorizontalScreen = false;
                }
            },
            false,
        );

        if (windowWidth > windowHeight) {
            this.isHorizontalScreen = true;
        }
    };

    playerPlay = () => {
        const videoTag = this.videoRef.current;
        // const { content } = this.props;
        // const guid = content.guid || '';
        // const readUrl = sessionStroe.getSession('isAlreadyPlay') || '';

        this.isWifi = true;
        this.isContinuePlay = true;
        videoTag.play();

        if (window.setAllowedOnDataNet) {
            window.setAllowedOnDataNet(true);
        }
        // if (!readUrl.includes(guid)) {
        //     sessionStroe.setSession('isAlreadyPlay', `${readUrl},${guid}`);
        // }
    };

    videoBoxStyleHandle = () => {
        const boxWidth = this.ref.current.offsetWidth;

        this.setState({
            videoHeight: (boxWidth * 9) / 16,
        });
    };

    playVideo = () => {
        const videoTag = this.videoRef.current;
        // const { content } = this.props;
        // const guid = content.guid || '';
        // const readUrl =
        //     (sessionStroe.getSession('isAlreadyPlay') && sessionStroe.getSession('isAlreadyPlay').toString()) || '';

        this.setState({
            isShowPlayIcon: false,
        });

        if (this.isWifi) {
            videoTag.play();
        } else {
            this.setState({
                isShowPopup: true,
            });
        }
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content } = this.props;
        const { videoHeight, isShowPopup, isShowPlayIcon } = this.state;
        const videoBoxStyle = {
            height: videoHeight,
        };
        const videoPoster = {
            backgroundImage: `url(${content.bigPosterUrl})`,
            backgroundSize: 'cover',
        };
        const videoStyle = {
            height: videoHeight,
            display: isShowPlayIcon ? 'none' : 'block',
        };

        return (
            <div className={styles.visibleVideo} ref={this.ref} style={videoBoxStyle}>
                <div className={styles.videoBox} style={videoBoxStyle}>
                    <video
                        ref={this.videoRef}
                        src={content.mobileUrl}
                        poster={content.bigPosterUrl}
                        controls="controls"
                        hbs-noshowcontrolsatstart="true"
                        hbs-showdefaultprogress="true"
                        hbs-fullscreentitle="true"
                        preload="true"
                        className={styles.docVideo}
                        style={videoStyle}
                        controlsList="nodownload"
                        volume="0.5"
                        playsinline=""
                        webkit-playsinline=""
                        x-webkit-airplay="allow"
                    />
                    {isShowPlayIcon && (
                        <div className={styles.videoPoster} style={videoPoster}>
                            <span className={styles.videoPlayIcon} onClick={this.playVideo} />
                        </div>
                    )}
                </div>
                {isShowPopup && (
                    <div onClick={this.playerPlay} className={styles.videoInfo} style={videoBoxStyle}>
                        <div className={styles.videoInfoBox}>
                            <div className={styles.videoFilesize}>
                                播放将消耗{content.fileSize ? `${(content.fileSize / 1024).toFixed(2)}M` : ''}流量
                            </div>
                            <span className={styles.videoContinus}>继续播放</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default errorBoundary(articleVideo);
